export const Languages = {
  state: () => ({
    data: []
  })
}
